import {Attentions} from "../../models/attentions/attention";
import {apiService} from "../api.service";

export class AttentionService {

    getAttentions(): Promise<Attentions> {
        return apiService
            .get<Attentions>("attentions")
            .then((x) => x.data);
    }
}

export const attentionService = new AttentionService();
